import React from "react";
import "./Time.css";

function Time(props) {
  return <span className={"time" + (props.blink ? " blink" : "")}>{props.children}</span>;
}

export default Time;
